const config = {
  env: "local",
  // apiUrl: "http://localhost:8000/admin/",
  apiUrl: "https://api.techsolar.co.in/admin/",
  // apiUrl: "https://5s3wsb95-8000.inc1.devtunnels.ms/admin/",
};

export default config;
